import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

function coerceToDate(value: any): Date | null {
  if (value == null || value === '') {
    return null;
  }
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'number') {
    if (!isFinite(value)) {
      return null;
    }
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed || trimmed === '-' || trimmed === 'N/A' || trimmed === 'null' || trimmed === 'undefined') {
      return null;
    }
    const date = /^\d+$/.test(trimmed) ? new Date(Number(trimmed)) : new Date(trimmed);
    return isNaN(date.getTime()) ? null : date;
  }
  return null;
}

function resolveLocale(userData: any): string | undefined {
  const candidate = userData?.languages?.locale;
  if (typeof candidate !== 'string') {
    return undefined;
  }
  const normalized = candidate.trim();
  return normalized || undefined;
}

@Pipe({
    name: 'customDateTime',
    standalone: false
})
export class CustomDateTimeFormatPipe extends DatePipe implements PipeTransform {
	transform(value: any, args?: any): any {
		const date = coerceToDate(value);
		if (!date) {
			return '';
		}
		const userData = localStorage.getItem('loginUserValue') && JSON.parse(localStorage.getItem('loginUserValue'));
		try {
			return super.transform(date, 'EE d MMM, y h:mm a', '', resolveLocale(userData));
		} catch {
			return '';
		}
	}
}
